import { memo } from 'react';
// import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg'
import {
  ClipPath as _ClipPath,
  Defs as _Defs,
  G as _G,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg,
} from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_G clipPath="url(#clip0_3102_57537)">
        <_Path
          d="M44.5734 25.8967H36.8487V5.32815H44.5701C44.7844 5.32772 44.9967 5.36956 45.1948 5.45127C45.3929 5.53297 45.573 5.65295 45.7246 5.80433C45.8763 5.9557 45.9967 6.1355 46.0788 6.33344C46.1609 6.53139 46.2031 6.74358 46.2031 6.95787V24.267C46.2031 24.6992 46.0314 25.1138 45.7258 25.4194C45.4202 25.725 45.0056 25.8967 44.5734 25.8967Z"
          fill="#D11A2A"
        />
        <_Path
          d="M34.8477 25.8967L26.5677 39.1316C26.2468 39.655 25.7957 40.0864 25.2584 40.3835C24.7212 40.6807 24.116 40.8335 23.5021 40.827C23.0194 40.8441 22.5381 40.7644 22.0867 40.5926C21.6353 40.4207 21.2229 40.1602 20.8738 39.8264C20.5246 39.4926 20.2459 39.0923 20.054 38.649C19.8621 38.2058 19.7609 37.7286 19.7564 37.2456V27.7597H5.4438C4.91481 27.7429 4.39538 27.6142 3.91975 27.3821C3.44411 27.15 3.02308 26.8197 2.68438 26.413C2.34568 26.0063 2.097 25.5324 1.95475 25.0227C1.8125 24.5129 1.77989 23.9787 1.85909 23.4554L4.46466 6.63587C4.57596 5.73705 5.01168 4.90982 5.68993 4.30962C6.36818 3.70943 7.24226 3.37758 8.14794 3.37644H29.5347C30.5532 3.37315 31.5554 3.60644 32.4655 4.05987L34.8148 5.23287M34.8477 25.8967V5.32815V25.8967Z"
          fill="#D11A2A"
        />
      </_G>
      <_Defs>
        <_ClipPath id="clip0_3102_57537">
          <_Rect width="46" height="46" fill="white" transform="matrix(-1 0 0 -1 46 46)" />
        </_ClipPath>
      </_Defs>
    </_Svg>
  );
};
Icon.displayName = 'NotHelpFullSolid';
const NotHelpFullSolid = memo(themed(Icon));
export { NotHelpFullSolid };
